const Menu = [
  { path: '/', icon: 'fa fa-sitemap', title: 'Home' },
  { id: 'dynamic-review-menu' }, // メニューsidebar-navにて編集
  { id: 'dynamic-ranking-menu' }, // メニューsidebar-navにて編集
  { id: 'dynamic-barcode-menu' }, // メニューsidebar-navにて編集
  { id: 'dynamic-rakuten-event-menu' }, // メニューsidebar-navにて編集
  {
    path: '/purchase',
    icon: 'fa fa-truck',
    title: '仕入・商品管理',
    children: [
      { path: '/purchase/products', title: '商品一覧' },
      { path: '/purchase/suppliers', title: '仕入先管理' },
      { path: '/purchase/purchase-orders', title: '仕入伝票管理' },
    ]
  },
  {
    path: '/master',
    icon: 'fa fa-database',
    title: '共通マスター管理',
    children: [
      { path: '/master/categories', title: '自社ジャンル管理' },
      { path: '/master/variant-options', title: 'カラー・サイズ共通マスタ' },
      { path: '/master/category-mapping', title: 'モール紐付け設定' },
    ]
  },
  /*
  { path: '/menu', icon: 'fa fa-align-left', title: 'Menu Level',
    children: [
      { path: '/menu/menu-1-1', title: 'Menu 1.1',
        children: [
          { path: '/menu/menu-1-1/menu-2-1', title: 'Menu 2.1',
            children: [
              { path: '/menu/menu-1-1/menu-2-1/menu-3-1', title: 'Menu 3.1' },
              { path: '/menu/menu-1-1/menu-2-1/menu-3-2', title: 'Menu 3.2' }
            ]
          },
          { path: '/menu/menu-1-1/menu-2-2', title: 'Menu 2.2' },
          { path: '/menu/menu-1-1/menu-2-3', title: 'Menu 2.3' },
        ]
      },
      { path: '/menu/menu-1-2', title: 'Menu 1.2' },
      { path: '/menu/menu-1-3', title: 'Menu 1.3' },
    ]
  }
  */
  { path: "https://nc.twinklegirls.jp", icon: "fa-solid fa-server", title: "NextCloud" },
]

export default Menu;